// Libs
import { Box, Button, Card, CardContent, CardMedia, Stack, Typography } from '@mui/material';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';

// Components, Layouts, Pages

// Others
import { TConnectionStatus } from '~/utils/type/common';

// Styles, images, icons
import { icons } from '~/assets';
import styles from './IntegrationPackage.module.scss';

type Props = {
  imgUrl?: string;
  title: string;
  subtitle: string;
  status?: TConnectionStatus;
  onCallback: () => void;
};

const cx = classNames.bind(styles);

const IntegrationPackage = (props: Props) => {
  //#region Destructuring Props
  const { imgUrl, title, subtitle, status = 'disconnected', onCallback } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/integration', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleClick = () => {
    onCallback();
  };
  //#endregion Handle Function

  return (
    <Card component={'div'} className={cx('container')}>
      <Stack className={cx('imgGr')} justifyContent={'center'}>
        <CardMedia
          component={'img'}
          alt={t('common_alt_img', { ns: 'common/base' })}
          className={cx('image')}
          image={imgUrl ?? icons.commonIconLogoFull}
        />
      </Stack>

      <CardContent className={cx('content')}>
        <Box className={cx('titleGr')}>
          <Typography component='p' className={cx('title')} variant='body2'>
            {title}
          </Typography>
        </Box>

        <Box className={cx('subtitleGr')}>
          <Typography component='p' className={cx('subtitle')} variant='caption'>
            {subtitle}
          </Typography>
        </Box>

        <Button
          variant={status === 'connected' ? 'contained' : 'outlined'}
          color={status === 'connected' ? 'error' : 'primary'}
          className={cx('button')}
          type='button'
          onClick={handleClick}
        >
          {status === 'connected' ? t('integration_btn_disconnect') : t('integration_btn_connect')}
        </Button>
      </CardContent>
    </Card>
  );
};

export default IntegrationPackage;
